import dsbridge from 'dsbridge'
import wx from 'weixin-js-sdk'
import browser from './browser'
import Log from './log'

// 封装app操作功能
export const AppOperate = {
  // 保存当前登录用户标识
  saveLoginUserData: userData => {
    if (browser.versions.tui) {
      dsbridge.call('UpdateLocalInfo.saveUserInfo', userData)
    }
    localStorage.setItem('userData', JSON.stringify(userData))
    localStorage.setItem('everLogined', userData.mobile)
  },

  // 获取当前登录用户标识
  getLoginUserData: () => {
    let data = null
    if (browser.versions.tui) {
      let response = dsbridge.call('LocalInfo.getUserInfo', '')
      console.log(response)
      if (response === '' || response === undefined || response === 'false') {
        return {}
      }
      data = JSON.parse(response)
    } else {
      let userData = localStorage.getItem('userData')
      if (!userData) {
        return {}
      }
      data = JSON.parse(userData)
    }
    return data
  },

  // 打开二维码
  openQrScan: () => {
    if (browser.versions.tui) {
      dsbridge.call('Operate.openQrScan', '')
    } else if (browser.versions.weChat) {
      wx.scanQRCode({
        needResult: 0,
        scanType: ['qrCode', 'barCode'],
        success: function (res) {
          console.log(res)
        }
      })
    }
  },

  // 获取上传头像权限
  openUpload: callBack => {
    if (browser.versions.tui) {
      dsbridge.call('Operate.uploadHeadIcon', '', callBack)
    }
  },

  // 通知app检查更新
  checkUpdate: () => {
    if (browser.versions.tui) {
      dsbridge.call('Operate.checkUpdate', '')
    }
  },

  // 调出支付
  callPay: (payType, payParam, callBack) => {
    if (browser.versions.tui) {
      dsbridge.call('Operate.callPay', { payType, payParam }, callBack)
    }
  },

  // 获取当前版本号
  getVersion: () => {
    if (browser.versions.tui) {
      return dsbridge.call('LocalInfo.getVersionCode', '')
    }
  },

  // 获取社保卡界面
  openESSC: params => {
    if (browser.versions.tui) {
      dsbridge.call('Operate.openESSC', params)
    }
  },
  getNotchPhone: callback => {
    // return 'true'
    let standardStatusBar = JSON.stringify({ hasNotch: false, statusBarHeight: 20 })
    let xStatusBar = JSON.stringify({ hasNotch: true, statusBarHeight: 44, isX: true })
    if (browser.versions.tui) {
      if (browser.versions.iPhone) {
        if (AppCallback.getIphoneXAbove()) {
          callback(xStatusBar)
        } else {
          callback(standardStatusBar)
        }
      } else {
        dsbridge.call('Operate.getNotchPhone', callback)
      }
    } else {
      callback(standardStatusBar)
    }
  }
}

// 封装app原生回调
export const AppCallback = {
  // 响应原生界面重回当前屏幕事件
  onViewWillAppear: callbackFunc => {
    if (browser.versions.tui) {
      dsbridge.register('AppCall', {
        tag: 'AppCall',
        viewWillAppear: callbackFunc
      })
    }
  },

  // 接收扫描二维码返回的信息
  getScanData: callbackFunc => {
    if (browser.versions.tui) {
      dsbridge.register('qrScan', {
        tag: 'qrScan',
        getScanData: callbackFunc
      })
    }
  },

  // 响应按下返回键
  onBackPress: callbackFunc => {
    if (browser.versions.tui) {
      dsbridge.register('AppCall', {
        tag: 'AppCall',
        onBackPress: callbackFunc
      })
    }
  },

  // 判断是否是iphoneX以上机型
  getIphoneXAbove: () => {
    let response = dsbridge.call('LocalInfo.isIphoneXAbove', '')
    if (response === '' || response === undefined) {
      return null
    }
    return JSON.parse(response)
  }
}

// 封装app界面导航、跳转
export const AppNavigator = {
  // 确保登录状态，否则自动跳转登录提示
  ensureLoginStatus: (func, parentRef) => {
    Log.debug('AppNavigator::ensureLoginStatus', 'call')
    let userData = AppOperate.getLoginUserData()
    // if (JSON.stringify(userData) !== '{}') {
    func(userData)
    // }
    // AppNavigator.openView('/login', null, parentRef)
  },
  // 根据视图名打开界面，作废
  openView: (viewName, params, parentRef) => {
    Log.debug('AppNavigator::openView', [viewName, params])
    parentRef.$router.goto({ path: viewName, query: params })
  }
}



// WEBPACK FOOTER //
// ./src/utils/appfunc.js